import store from '../../core/store'
import { setCheckoutFinishedSuccess } from '../../reducers/orderSlice'
import { http } from '../../services/baseService'

const Vtex = function (paymentGateway) {
  this.paymentGateway = paymentGateway
  this.checkout = null
  this.orderId = null

  this.createQuote = ({ order }) => {
    this.orderId = order.id
  }

  this.startCheckout = async () => {
    let response
    try {
      response = await http.post('/api/orders/startVtexCheckout', {
        paymentGatewayId: this.paymentGateway.id,
        orderId: this.orderId,
      })
    } catch (err) {
      console.error(err)
      return
    }

    this.checkout = response.data
  }

  // ESTE POST MESSAGE ENVÍA LOS PRODUCTOS A UNA FUNCIÓN GTM EN VTEX IO QUE AGREGA EL PRODUCTO AL CARRITO
  this.addToCart = async ({ product, orderFormId }) => {
    try {
      const items = JSON.stringify([
        {
          id: String(product.sku).trim(),
          quantity: Number(product.quantity),
          seller: '1',
        },
      ])

      window.parent.postMessage(
        {
          type: 'gojiraf:add-to-cart',
          orderFormId,
          items,
        },
        '*',
      )

      return {
        success: true,
        message: 'Product added to cart successfully',
      }
    } catch (err) {
      console.error(err)
      throw err
    }
  }

  this.goToCheckout = ({ checkoutWindow }) => {
    const url = new URL(`${this.checkout.checkout.url}`)
    const params = new URLSearchParams(url.search)

    params.set('utm_source', 'gojiraf')
    params.set('utm_medium', 'participant')
    params.set('utm_campaign', 'socios')
    url.search = params.toString()

    if (typeof checkoutWindow === 'object') {
      checkoutWindow.location.href = url.toString()
      checkoutWindow.focus()
    } else {
      window.open(url.toString(), checkoutWindow)
    }

    store.dispatch(setCheckoutFinishedSuccess(true))
  }
}

export default Vtex
